import { ExtendedIam } from "./extendedIam";
import { HttpRequest, SDKError, config } from "@smash-sdk/core";
import { errors } from "./errors";
export * from "./errors";
export * from "./types/UpdateTeam/UpdateTeam";
export * from "./types/UpdateTeamGroup/UpdateTeamGroup";
export * from "./types/UpdateTeamUser/UpdateTeamUser";
export * from "./types/UpdateUser/UpdateUser";
export * from "./types/UpdateUserMfa/UpdateUserMfa";
export * from "./types/UpdateUserSCIM/UpdateUserSCIM";
export * from "./types/VerifyMfaFactor/VerifyMfaFactor";
export * from "./types/VerifyOtp/VerifyOtp";
export * from "./types/VerifyUserMfaFactor/VerifyUserMfaFactor";
export * from "./types/GetTeamUser/GetTeamUser";
export * from "./types/GetUser/GetUser";
export * from "./types/GetUserMfa/GetUserMfa";
export * from "./types/GetUserSCIM/GetUserSCIM";
export * from "./types/InviteTeamUser/InviteTeamUser";
export * from "./types/InviteUser/InviteUser";
export * from "./types/ListGroupRoles/ListGroupRoles";
export * from "./types/ListGroupTeams/ListGroupTeams";
export * from "./types/ListGroupUsers/ListGroupUsers";
export * from "./types/ListGroups/ListGroups";
export * from "./types/ListGroupsSCIM/ListGroupsSCIM";
export * from "./types/ListPolicies/ListPolicies";
export * from "./types/ListProviders/ListProviders";
export * from "./types/ListRoles/ListRoles";
export * from "./types/ListTeamGroupRoles/ListTeamGroupRoles";
export * from "./types/ListTeamGroupUsers/ListTeamGroupUsers";
export * from "./types/ListTeamGroups/ListTeamGroups";
export * from "./types/ListTeamRoles/ListTeamRoles";
export * from "./types/ListTeamUserGroups/ListTeamUserGroups";
export * from "./types/ListTeamUserRoles/ListTeamUserRoles";
export * from "./types/ListTeamUsers/ListTeamUsers";
export * from "./types/ListTeams/ListTeams";
export * from "./types/ListUserGroups/ListUserGroups";
export * from "./types/ListUserGroupsRoles/ListUserGroupsRoles";
export * from "./types/ListUserGroupsTeams/ListUserGroupsTeams";
export * from "./types/ListUserRoles/ListUserRoles";
export * from "./types/ListUserTeams/ListUserTeams";
export * from "./types/ListUsers/ListUsers";
export * from "./types/ListUsersSCIM/ListUsersSCIM";
export * from "./types/PatchGroupSCIM/PatchGroupSCIM";
export * from "./types/PatchUserSCIM/PatchUserSCIM";
export * from "./types/RenewToken/RenewToken";
export * from "./types/ResetMfaFactor/ResetMfaFactor";
export * from "./types/ResetPassword/ResetPassword";
export * from "./types/ResetUserMfaFactor/ResetUserMfaFactor";
export * from "./types/RotateKey/RotateKey";
export * from "./types/RotateUserKey/RotateUserKey";
export * from "./types/SamlSignon/SamlSignon";
export * from "./types/SendOtp/SendOtp";
export * from "./types/SsoSignin/SsoSignin";
export * from "./types/UpdateAccount/UpdateAccount";
export * from "./types/UpdateGroup/UpdateGroup";
export * from "./types/UpdateGroupSCIM/UpdateGroupSCIM";
export * from "./types/UpdateManagedPolicy/UpdateManagedPolicy";
export * from "./types/UpdateMfa/UpdateMfa";
export * from "./types/UpdatePassword/UpdatePassword";
export * from "./types/UpdatePolicy/UpdatePolicy";
export * from "./types/UpdateProvider/UpdateProvider";
export * from "./types/UpdateRole/UpdateRole";
export * from "./types/UpdateSecurity/UpdateSecurity";
export * from "./types/CreateAccount/CreateAccount";
export * from "./types/CreateGroup/CreateGroup";
export * from "./types/CreateGroupSCIM/CreateGroupSCIM";
export * from "./types/CreateMfaFactorSecret/CreateMfaFactorSecret";
export * from "./types/CreatePolicy/CreatePolicy";
export * from "./types/CreateProvider/CreateProvider";
export * from "./types/CreateRole/CreateRole";
export * from "./types/CreateTeam/CreateTeam";
export * from "./types/CreateToken/CreateToken";
export * from "./types/CreateUser/CreateUser";
export * from "./types/CreateUserMfaFactorSecret/CreateUserMfaFactorSecret";
export * from "./types/CreateUserSCIM/CreateUserSCIM";
export * from "./types/CreateUserToken/CreateUserToken";
export * from "./types/DeleteAccount/DeleteAccount";
export * from "./types/DeleteGroup/DeleteGroup";
export * from "./types/DeleteGroupSCIM/DeleteGroupSCIM";
export * from "./types/DeletePolicy/DeletePolicy";
export * from "./types/DeleteProvider/DeleteProvider";
export * from "./types/DeleteRole/DeleteRole";
export * from "./types/DeleteTeam/DeleteTeam";
export * from "./types/DeleteUser/DeleteUser";
export * from "./types/DeleteUserSCIM/DeleteUserSCIM";
export * from "./types/DetachGroupRole/DetachGroupRole";
export * from "./types/DetachGroupUser/DetachGroupUser";
export * from "./types/DetachRolePolicy/DetachRolePolicy";
export * from "./types/DetachTeamGroup/DetachTeamGroup";
export * from "./types/DetachTeamGroupRole/DetachTeamGroupRole";
export * from "./types/DetachTeamGroupUser/DetachTeamGroupUser";
export * from "./types/DetachTeamRole/DetachTeamRole";
export * from "./types/DetachTeamUser/DetachTeamUser";
export * from "./types/DetachTeamUserRole/DetachTeamUserRole";
export * from "./types/DetachUserRole/DetachUserRole";
export * from "./types/ForgotPassword/ForgotPassword";
export * from "./types/GetAccount/GetAccount";
export * from "./types/GetGroup/GetGroup";
export * from "./types/GetGroupSCIM/GetGroupSCIM";
export * from "./types/GetMfa/GetMfa";
export * from "./types/GetPolicy/GetPolicy";
export * from "./types/GetProvider/GetProvider";
export * from "./types/GetResourceTypes/GetResourceTypes";
export * from "./types/GetRole/GetRole";
export * from "./types/GetSchemas/GetSchemas";
export * from "./types/GetSecurity/GetSecurity";
export * from "./types/GetServiceProviderConfig/GetServiceProviderConfig";
export * from "./types/GetSigninConfiguration/GetSigninConfiguration";
export * from "./types/GetTeam/GetTeam";
export * from "./types/GetTeamGroup/GetTeamGroup";
export * from "./types/AcceptInvitation/AcceptInvitation";
export * from "./types/AcceptUserInvitation/AcceptUserInvitation";
export * from "./types/AttachGroupRole/AttachGroupRole";
export * from "./types/AttachGroupUser/AttachGroupUser";
export * from "./types/AttachRolePolicy/AttachRolePolicy";
export * from "./types/AttachTeamGroup/AttachTeamGroup";
export * from "./types/AttachTeamGroupRole/AttachTeamGroupRole";
export * from "./types/AttachTeamGroupUser/AttachTeamGroupUser";
export * from "./types/AttachTeamRole/AttachTeamRole";
export * from "./types/AttachTeamUser/AttachTeamUser";
export * from "./types/AttachTeamUserRole/AttachTeamUserRole";
export * from "./types/AttachUserRole/AttachUserRole";
export * from "./types/ChangePassword/ChangePassword";
export * from "./types/DecodeToken/DecodeToken";
const endpoints = {
    "ca-central-1": "https://iam.ca-central-1.fromsmash.co",
    "eu-central-1": "https://iam.eu-central-1.fromsmash.co",
    "eu-west-1": "https://iam.eu-west-1.fromsmash.co",
    "eu-west-2": "https://iam.eu-west-2.fromsmash.co",
    "eu-west-3": "https://iam.eu-west-3.fromsmash.co",
    "us-east-1": "https://iam.us-east-1.fromsmash.co",
    "us-east-2": "https://iam.us-east-2.fromsmash.co",
    "us-west-1": "https://iam.us-west-1.fromsmash.co",
    "us-west-2": "https://iam.us-west-2.fromsmash.co",
};
config.setHosts("iam", endpoints, false);
export class Iam extends ExtendedIam {
    constructor(params = {}) {
        super({ service: "iam", ...params, type: "regional", userAgent: "@smash-sdk/iam@2.0.0-alpha.2" });
        this.errors = errors;
    }
    updateTeam(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        name: params["name"],
                        description: params["description"],
                        config: params["config"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateTeamError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    updateTeamGroup(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId/group/:groupId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        name: params["name"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateTeamGroupError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    updateTeamUser(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId/user/:userId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        username: params["username"],
                        lastName: params["lastName"],
                        firstName: params["firstName"],
                        language: params["language"],
                        status: params["status"],
                        authenticationMode: params["authenticationMode"],
                        label: params["label"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateTeamUserError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    updateUser(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/user/:userId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        username: params["username"],
                        lastName: params["lastName"],
                        firstName: params["firstName"],
                        language: params["language"],
                        status: params["status"],
                        authenticationMode: params["authenticationMode"],
                        label: params["label"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateUserError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    updateUserMfa(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/user/:userId/mfa",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        defaultFactor: params["defaultFactor"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateUserMfaError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    updateUserSCIM(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/Users/:userId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        schemas: params["schemas"],
                        userName: params["userName"],
                        name: params["name"],
                        emails: params["emails"],
                        displayName: params["displayName"],
                        locale: params["locale"],
                        active: params["active"],
                        groups: params["groups"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateUserSCIMError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    verifyMfaFactor(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/mfa/:factorId/verify",
                    headers: {},
                    pathParameters: {
                        factorId: params["factorId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        otp: params["otp"],
                        token: params["token"],
                        secret: params["secret"],
                    },
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.VerifyMfaFactorError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    verifyOtp(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/otp/verify",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        factor: params["factor"],
                        otp: params["otp"],
                        token: params["token"],
                    },
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.VerifyOtpError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    verifyUserMfaFactor(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/user/:userId/mfa/:factorId/verify",
                    headers: {},
                    pathParameters: {
                        userId: params["userId"],
                        factorId: params["factorId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        otp: params["otp"],
                        token: params["token"],
                        secret: params["secret"],
                    },
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.VerifyUserMfaFactorError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getTeamUser(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/user/:userId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetTeamUserError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getUser(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/user/:userId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetUserError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getUserMfa(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/user/:userId/mfa",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetUserMfaError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getUserSCIM(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/Users/:userId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetUserSCIMError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    inviteTeamUser(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId/user/:userId/invite",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.InviteTeamUserError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    inviteUser(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/user/:userId/invite",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.InviteUserError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listGroupRoles(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/group/:groupId/roles",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListGroupRolesError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listGroupTeams(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/group/:groupId/teams",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListGroupTeamsError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listGroupUsers(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/group/:groupId/users",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListGroupUsersError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listGroups() {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/groups",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListGroupsError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listGroupsSCIM(params = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/Groups",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        startIndex: params["startIndex"],
                        count: params["count"],
                        filter: params["filter"],
                        excludedAttributes: params["excludedAttributes"],
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListGroupsSCIMError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listPolicies() {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/policies",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListPoliciesError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listProviders() {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/providers",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListProvidersError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listRoles() {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/roles",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListRolesError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listTeamGroupRoles(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/group/:groupId/roles",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListTeamGroupRolesError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listTeamGroupUsers(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/group/:groupId/users",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListTeamGroupUsersError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listTeamGroups(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/groups",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListTeamGroupsError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listTeamRoles(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/roles",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListTeamRolesError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listTeamUserGroups(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/user/:userId/groups",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListTeamUserGroupsError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listTeamUserRoles(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/user/:userId/roles",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListTeamUserRolesError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listTeamUsers(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/users",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListTeamUsersError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listTeams() {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/teams",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListTeamsError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listUserGroups(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/user/:userId/groups",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListUserGroupsError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listUserGroupsRoles(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/user/:userId/groups/roles",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListUserGroupsRolesError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listUserGroupsTeams(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/user/:userId/groups/teams",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListUserGroupsTeamsError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listUserRoles(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/user/:userId/roles",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListUserRolesError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listUserTeams(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/user/:userId/teams",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListUserTeamsError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listUsers() {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/users",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListUsersError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listUsersSCIM(params = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/Users",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        startIndex: params["startIndex"],
                        count: params["count"],
                        filter: params["filter"],
                        excludedAttributes: params["excludedAttributes"],
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListUsersSCIMError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    patchGroupSCIM(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PATCH",
                    path: "/Groups/:groupId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        schemas: params["schemas"],
                        Operations: params["Operations"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.PatchGroupSCIMError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    patchUserSCIM(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PATCH",
                    path: "/Users/:userId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        schemas: params["schemas"],
                        Operations: params["Operations"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.PatchUserSCIMError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    renewToken(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/token",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        refreshToken: params["refreshToken"],
                    },
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.RenewTokenError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    resetMfaFactor(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/mfa/:factorId/reset",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        factorId: params["factorId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ResetMfaFactorError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    resetPassword(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/password/reset",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        password: params["password"],
                        account: params["account"],
                        secret: params["secret"],
                        id: params["id"],
                    },
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ResetPasswordError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    resetUserMfaFactor(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/user/:userId/mfa/:factorId/reset",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                        factorId: params["factorId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ResetUserMfaFactorError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    rotateKey() {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/key/rotate",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.RotateKeyError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    rotateUserKey(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/user/:userId/key/rotate",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.RotateUserKeyError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    samlSignon(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/saml/signon",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        SAMLResponse: params["SAMLResponse"],
                        RelayState: params["RelayState"],
                    },
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.SamlSignonError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    sendOtp(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/otp/send",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        factor: params["factor"],
                        token: params["token"],
                    },
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.SendOtpError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    ssoSignin(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/sso/signin",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        username: params["username"],
                    },
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.SsoSigninError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    updateAccount(params = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/account",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        username: params["username"],
                        password: params["password"],
                        firstName: params["firstName"],
                        lastName: params["lastName"],
                        language: params["language"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateAccountError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    updateGroup(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/group/:groupId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        name: params["name"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateGroupError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    updateGroupSCIM(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/Groups/:groupId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        schemas: params["schemas"],
                        displayName: params["displayName"],
                        groupType: params["groupType"],
                        members: params["members"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateGroupSCIMError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    updateManagedPolicy(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/managedPolicy/:policyId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        policyId: params["policyId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        description: params["description"],
                        statement: params["statement"],
                        tags: params["tags"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateManagedPolicyError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    updateMfa(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/mfa",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        defaultFactor: params["defaultFactor"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateMfaError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    updatePassword(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/password/update",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        currentPassword: params["currentPassword"],
                        newPassword: params["newPassword"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdatePasswordError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    updatePolicy(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/policy/:policyId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        policyId: params["policyId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        description: params["description"],
                        statement: params["statement"],
                        tags: params["tags"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdatePolicyError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    updateProvider(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/provider/:name",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        name: params["name"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        idpUrl: params["idpUrl"],
                        certificate: params["certificate"],
                        status: params["status"],
                        audienceUri: params["audienceUri"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateProviderError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    updateRole(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/role/:roleId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        roleId: params["roleId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        description: params["description"],
                        tags: params["tags"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateRoleError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    updateSecurity(params = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/security",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        account: params["account"],
                        user: params["user"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateSecurityError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    createAccount(params = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/account",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        username: params["username"],
                        password: params["password"],
                        lastName: params["lastName"],
                        firstName: params["firstName"],
                        language: params["language"],
                    },
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateAccountError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    createGroup(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/group",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        name: params["name"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateGroupError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    createGroupSCIM(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/Groups",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        schemas: params["schemas"],
                        externalId: params["externalId"],
                        displayName: params["displayName"],
                        meta: params["meta"],
                        members: params["members"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateGroupSCIMError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    createMfaFactorSecret(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/mfa/:factorId/secret",
                    headers: {},
                    pathParameters: {
                        factorId: params["factorId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        token: params["token"],
                    },
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateMfaFactorSecretError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    createPolicy(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/policy",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        name: params["name"],
                        description: params["description"],
                        statement: params["statement"],
                        tags: params["tags"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreatePolicyError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    createProvider(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/provider",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        issuer: params["issuer"],
                        name: params["name"],
                        type: params["type"],
                        idpUrl: params["idpUrl"],
                        certificate: params["certificate"],
                        metadata: params["metadata"],
                        status: params["status"],
                        audienceUri: params["audienceUri"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateProviderError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    createRole(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/role",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        name: params["name"],
                        description: params["description"],
                        tags: params["tags"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateRoleError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    createTeam(params = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/team",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        name: params["name"],
                        description: params["description"],
                        domain: params["domain"],
                        config: params["config"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateTeamError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    createToken(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/token",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        username: params["username"],
                        password: params["password"],
                    },
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateTokenError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    createUser(params = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/user",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        username: params["username"],
                        password: params["password"],
                        lastName: params["lastName"],
                        firstName: params["firstName"],
                        language: params["language"],
                        status: params["status"],
                        authenticationMode: params["authenticationMode"],
                        label: params["label"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateUserError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    createUserMfaFactorSecret(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/user/:userId/mfa/:factorId/secret",
                    headers: {},
                    pathParameters: {
                        userId: params["userId"],
                        factorId: params["factorId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        token: params["token"],
                    },
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateUserMfaFactorSecretError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    createUserSCIM(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/Users",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        schemas: params["schemas"],
                        externalId: params["externalId"],
                        userName: params["userName"],
                        active: params["active"],
                        emails: params["emails"],
                        meta: params["meta"],
                        name: params["name"],
                        displayName: params["displayName"],
                        locale: params["locale"],
                        groups: params["groups"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateUserSCIMError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    createUserToken(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/user/:userId/token",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        scope: params["scope"],
                        ip: params["ip"],
                        tokenDuration: params["tokenDuration"],
                        refreshTokenDuration: params["refreshTokenDuration"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateUserTokenError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    deleteAccount() {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/account",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteAccountError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    deleteGroup(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/group/:groupId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteGroupError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    deleteGroupSCIM(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/Groups/:groupId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteGroupSCIMError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    deletePolicy(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/policy/:policyId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        policyId: params["policyId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeletePolicyError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    deleteProvider(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/provider/:issuer",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        issuer: params["issuer"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteProviderError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    deleteRole(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/role/:roleId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        roleId: params["roleId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteRoleError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    deleteTeam(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/team/:teamId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteTeamError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    deleteUser(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/user/:userId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteUserError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    deleteUserSCIM(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "DELETE",
                    path: "/Users/:userId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DeleteUserSCIMError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    detachGroupRole(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/group/:groupId/role/:roleId/detach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        groupId: params["groupId"],
                        roleId: params["roleId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DetachGroupRoleError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    detachGroupUser(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/group/:groupId/user/:userId/detach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        groupId: params["groupId"],
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DetachGroupUserError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    detachRolePolicy(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/role/:roleId/policy/:policyId/detach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        roleId: params["roleId"],
                        policyId: params["policyId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DetachRolePolicyError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    detachTeamGroup(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId/group/:groupId/detach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DetachTeamGroupError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    detachTeamGroupRole(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId/group/:groupId/role/:roleId/detach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        groupId: params["groupId"],
                        roleId: params["roleId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DetachTeamGroupRoleError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    detachTeamGroupUser(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId/group/:groupId/user/:userId/detach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        groupId: params["groupId"],
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DetachTeamGroupUserError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    detachTeamRole(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId/role/:roleId/detach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        roleId: params["roleId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DetachTeamRoleError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    detachTeamUser(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId/user/:userId/detach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DetachTeamUserError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    detachTeamUserRole(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId/user/:userId/role/:roleId/detach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        userId: params["userId"],
                        roleId: params["roleId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DetachTeamUserRoleError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    detachUserRole(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/user/:userId/role/:roleId/detach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                        roleId: params["roleId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.DetachUserRoleError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    forgotPassword(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/password/forgot",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        username: params["username"],
                    },
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ForgotPasswordError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getAccount() {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/account",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetAccountError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getGroup(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/group/:groupId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetGroupError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getGroupSCIM(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/Groups/:groupId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetGroupSCIMError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getMfa() {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/mfa",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetMfaError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getPolicy(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/policy/:policyId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        policyId: params["policyId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetPolicyError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getProvider(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/provider/:name",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        name: params["name"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetProviderError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getResourceTypes() {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/ResourceTypes",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetResourceTypesError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getRole(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/role/:roleId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        roleId: params["roleId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetRoleError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getSchemas() {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/Schemas",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetSchemasError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getSecurity() {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/security",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetSecurityError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getServiceProviderConfig() {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/ServiceProviderConfig",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetServiceProviderConfigError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getSigninConfiguration(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/signin/configuration/:username",
                    headers: {},
                    pathParameters: {
                        username: params["username"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetSigninConfigurationError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getTeam(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetTeamError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getTeamGroup(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/team/:teamId/group/:groupId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetTeamGroupError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    acceptInvitation(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/invitation/accept",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        password: params["password"],
                        secret: params["secret"],
                        account: params["account"],
                        user: params["user"],
                    },
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.AcceptInvitationError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    acceptUserInvitation(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/user/invitation/accept",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        password: params["password"],
                        secret: params["secret"],
                        account: params["account"],
                        user: params["user"],
                    },
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.AcceptUserInvitationError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    attachGroupRole(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/group/:groupId/role/:roleId/attach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        groupId: params["groupId"],
                        roleId: params["roleId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.AttachGroupRoleError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    attachGroupUser(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/group/:groupId/user/:userId/attach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        groupId: params["groupId"],
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.AttachGroupUserError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    attachRolePolicy(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/role/:roleId/policy/:policyId/attach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        roleId: params["roleId"],
                        policyId: params["policyId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.AttachRolePolicyError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    attachTeamGroup(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId/group/:groupId/attach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.AttachTeamGroupError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    attachTeamGroupRole(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId/group/:groupId/role/:roleId/attach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        groupId: params["groupId"],
                        roleId: params["roleId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.AttachTeamGroupRoleError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    attachTeamGroupUser(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId/group/:groupId/user/:userId/attach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        groupId: params["groupId"],
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.AttachTeamGroupUserError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    attachTeamRole(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId/role/:roleId/attach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        roleId: params["roleId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.AttachTeamRoleError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    attachTeamUser(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId/user/:userId/attach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        userId: params["userId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.AttachTeamUserError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    attachTeamUserRole(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/team/:teamId/user/:userId/role/:roleId/attach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        teamId: params["teamId"],
                        userId: params["userId"],
                        roleId: params["roleId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.AttachTeamUserRoleError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    attachUserRole(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/user/:userId/role/:roleId/attach",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        userId: params["userId"],
                        roleId: params["roleId"],
                    },
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.AttachUserRoleError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    changePassword(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/password/change",
                    headers: {},
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        password: params["password"],
                        account: params["account"],
                        secret: params["secret"],
                        id: params["id"],
                    },
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ChangePasswordError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
}
Iam.errors = errors;
